import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { BankStatementImportFileHelperContainerModel } from '../../../../../../models/aggregates/erp/index';
import { ApiVisa } from '../../shared';

@Injectable({
    providedIn: 'root'
})
export class BankStatementImportFileHelperService extends BaseApiTemplateService<BankStatementImportFileHelperContainerModel> {
    readonly url = Core2Config.DOMAIN_URL  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'default-bank-statement-helper/' + Core2Config.BACKOFFICE_EP_SUFFIX;

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'default-bank-statement-helper/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'default-bank-statement-helper/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.httpClient = http;
    }
}
